<ion-card>
  <ion-card-header>
    <ion-card-title>{{ texts.report.dateRange | translate }}</ion-card-title>
  </ion-card-header>

  <ion-card-content>
    <ion-grid>
      <ion-row>
        <ion-col>
          <mat-selection-list
            #selectionList
            (selectionChange)="newItemSelected(selectionList.selectedOptions.selected)">
            <mat-list-option
              *ngIf="showTotal"
              [disableRipple]="true"
              [value]="selectionTypes.Total"
              checkboxPosition="before"
              class="ion-margin-bottom" color="primary">
              <ion-text>Total</ion-text>
            </mat-list-option>

            <mat-list-option
              [disableRipple]="true"
              [value]="selectionTypes.Year"
              checkboxPosition="before"
              class="ion-margin-bottom" color="primary">
              <app-year-and-quartal-selection #yearSelection (dateRangeChanged)="onChange($event)"
                                              [defaultDate]="defaultDate"
                                              matLine
              ></app-year-and-quartal-selection>
            </mat-list-option>

            <mat-list-option
              [disableRipple]="true"
              [value]="selectionTypes.Month"
              checkboxPosition="before"
              class="ion-margin-bottom" color="primary">
              <app-month-selection #monthSelection (monthSelectionChanged)="onChange($event)"
                                    [defaultDate]="defaultDate"
                                    matLine>
                </app-month-selection>
            </mat-list-option>

            <mat-list-option
              [disableRipple]="true"
              [value]="selectionTypes.Week"
              checkboxPosition="before"
              class="ion-margin-bottom" color="primary">
              <app-week-selection #weekSelection (weekSelectionChanged)="onChange($event)" [defaultDate]="defaultDate"
                                  matLine></app-week-selection>
            </mat-list-option>

            <mat-list-option
              [disableRipple]="true"
              [value]="selectionTypes.Range"
              checkboxPosition="before"
              class="ion-margin-bottom" color="primary">
              <app-date-range-selection #formToSelection (dateRangeChanged)="onChange($event)"
                                        [defaultDate]="defaultDate"
                                        matLine
              ></app-date-range-selection>
            </mat-list-option>
          </mat-selection-list>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <mat-form-field
            *ngIf="istimeFrameVisible"
            appearance="outline"
            class="time-form-field">
            <mat-label>{{ texts.dayInfo.dateTime | translate }}</mat-label>
            <input
              (focusout)="onTimeChange()"
              [formControl]="time"
              matInput
              type="time"
            />
          </mat-form-field>

        </ion-col>
        <ion-col>
          <ion-button (click)="fullDayChange()"
                      *ngIf="istimeFrameVisible">
            {{ texts.report.fullDay | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>
